<template>
    <vx-chip :color="chipColor">
        <vs-avatar :icon="icon" />
        <span>
            <slot :text="timerText">
                {{ timerText }}
            </slot>
        </span>
    </vx-chip>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
    name: 'vx-time-elapsed-chip',
    props: {
        start: {
            type: [Date, String],
            required: true
        },
        end: {
            type: [Date, String]
        },
        color: {
            type: String,
            default: 'primary'
        },
        breakpoints: {
            type: Object,
            default: () => ({})
        },
        icon: {
            type: String,
            default: 'timer'
        }
    },
    computed: {
        ...mapGetters({
            now: 'now'
        }),
        localStart() {
            return new Date(this.start)
        },
        localEnd() {
            return this.end ? new Date(this.end) : this.now
        },
        chipColor() {
            let color = this.color
            if (!this.timerText) {
                return color
            }

            const elapsedSeconds = moment.duration(this.localEnd - this.localStart).asSeconds()
            const breakpoints = Object.entries(this.breakpoints)
                .defaultSort((kvp) => kvp[0])
                .reverse()

            for (const [seconds, c] of breakpoints) {
                if (elapsedSeconds >= Number(seconds)) {
                    color = c
                    break
                }
            }

            return color || 'primary'
        },
        timerText() {
            return this.localStart.humanize_time_diff(this.localEnd, true)
        }
    }
}
</script>
